import { AmicusFile } from "@/lib/conflix";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";
import { Button } from "./ui/button";
import { setDefaultResultOrder } from "dns";

function AmicusInfoDialog(props: { amicusFile: AmicusFile | null, dialogOpen: boolean, setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>}) {
    return (
        <Dialog open={props.dialogOpen}>
            
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>More Info</DialogTitle>
                </DialogHeader> 

                {props.amicusFile ? <ScrollArea className="max-h-64"> 
                <p>Party People ID: {props.amicusFile.PartyPeopleId}</p>
                <p>Party Phone: {props.amicusFile.PartyPhone}</p>
                <p>Party Email: {props.amicusFile.PartyEmail}</p>
                <p>Responsible Attorney First Name: {props.amicusFile.ResponsibleAttorneyFirstName}</p>
                <p>Responsible Attorney Middle Name: {props.amicusFile.ResponsibleAttorneyMiddleName}</p>
                <p>Responsible Attorney Last Name: {props.amicusFile.ResponsibleAttorneyLastName}</p>
                <p>Responsible Attorney Phone: {props.amicusFile.ResponsibleAttorneyPhone}</p>
                <p>Responsible Attorney Email: {props.amicusFile.ResponsibleAttorneyEmail}</p>
                <p>Responsible Lawyer People ID: {props.amicusFile.ResponsibleLawyerPeopleId}</p>
                <p>Party Type Label: {props.amicusFile.PartyTypeLabel}</p>
                <p>People2 File ID: {props.amicusFile.People2FileId}</p>
                <p>PO Box: {props.amicusFile.POBox}</p>
                <p>ZIP: {props.amicusFile.ZIP}</p>
                <p>Street: {props.amicusFile.Street}</p>
                <p>City: {props.amicusFile.City}</p>
                <p>State: {props.amicusFile.State}</p>
                <p>Country: {props.amicusFile.Country}</p>
                <p>Address Label: {props.amicusFile.AddressLabel}</p>
                <p>Address ID: {props.amicusFile.AddressId}</p>
                <p>Role Label: {props.amicusFile.RoleLabel}</p>
                <p>Represent People String: {props.amicusFile.RepresentPeopleString}</p>
                <p>Short File Name: {props.amicusFile.ShortFileName}</p>
                <p>File Created On: {props.amicusFile.FileCreatedOn}</p>
                <p>Party Company Name: {props.amicusFile.PartyCompanyName}</p>
                <p>Party First Name: {props.amicusFile.PartyFirstName}</p>
                <p>Party Middle Name: {props.amicusFile.PartyMiddleName}</p>
                <p>Party Last Name: {props.amicusFile.PartyLastName}</p>
                <p>File Type: {props.amicusFile.FileType}</p>
                <p>File ID: {props.amicusFile.FileId}</p>
                <p>ID: {props.amicusFile.id}</p>
                </ScrollArea>
             : ""}
                <DialogFooter className="sm:justify-start">
                    <DialogClose asChild>
                        <Button onClick={() => {props.setDialogOpen(false)}}>
                            Close
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default AmicusInfoDialog;